import { forwardRef } from "react";


// Experience Levels
const EXPERIENCE_LEVELS = [
  { value: "entry", label: "Entry Level (0-2 years)" },
  { value: "mid", label: "Mid Level (2-5 years)" },
  { value: "senior", label: "Senior Level (5-10 years)" },
  { value: "lead", label: "Lead Level (10+ years)" },
];

// Job Types
const JOB_TYPES = [
  { value: "full_time", label: "Full Time" },
  { value: "part_time", label: "Part Time" },
  { value: "contract", label: "Contract" },
  { value: "freelance", label: "Freelance" },
  { value: "internship", label: "Internship" },
];

const JobModal = forwardRef(
  (
    {
      isOpen,
      onClose,
      formData,
      onChange,
      onSave,
      creating,
      editingJob,
      formErrors,
    },
    modalRef
  ) => {
    if (!isOpen) return null;

    return (
 
<div
  className="fixed inset-0 z-[1000] flex items-start justify-center bg-black/40 px-4 py-10"
  onClick={(e) => e.stopPropagation()}
>
  <div
    ref={modalRef}
    className="flex w-full max-w-2xl max-h-[90vh] flex-col rounded-2xl border border-gray-200 bg-white shadow-xl overflow-hidden"
  >
  

    {/* Modal header - Fixed */}
    <div className="relative border-b border-gray-100 bg-white p-6 sticky top-0 z-10">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>
        <div>
          <h3 className="text-lg font-semibold text-gray-900">
            {editingJob ? "Edit Job" : "Create Job"}
          </h3>
          <p className="text-sm text-gray-500 mt-0.5">
            {editingJob ? "Update job details" : "Post a new job opportunity"}
          </p>
        </div>
      </div>
      <button
    onClick={onClose}
    className="absolute right-4 top-6 w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 transition"
  >
    <svg
      className="w-5 h-5 text-gray-500"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  </button>
    </div>

    {/* Scrollable content area */}
    <div className="overflow-y-auto flex-1">
      <div className="p-6 space-y-5">
        <input
          type="text"
          name="title"
          placeholder="Post Title"
          value={formData.title}
          onChange={onChange}
          className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all ${
            formErrors.title 
              ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
              : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
          }`}
        />

        <input
          type="text"
          name="job_title"
          placeholder="Job Title"
          value={formData.job_title}
          onChange={onChange}
          className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all ${
            formErrors.job_title 
              ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
              : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
          }`}
        />

        <input
          type="text"
          name="company_name"
          placeholder="Company Name"
          value={formData.company_name}
          onChange={onChange}
          className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all ${
            formErrors.company_name 
              ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
              : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
          }`}
        />

        <textarea
          name="content"
          placeholder="Job Description / Content"
          value={formData.content}
          onChange={onChange}
          rows={5}
          className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all resize-y ${
            formErrors.content 
              ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
              : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
          }`}
        />

        <input
          type="text"
          name="location"
          placeholder="Location (e.g., Remote, New York, London)"
          value={formData.location}
          onChange={onChange}
          className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all ${
            formErrors.location 
              ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
              : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
          }`}
        />

        {/* Fixed Remote Checkbox */}
        <div 
          className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl cursor-pointer hover:bg-gray-100 transition-colors"
          onClick={() => {
            // Toggle the remote_allowed value
            onChange({
              target: {
                name: 'remote_allowed',
                type: 'checkbox',
                checked: !formData.remote_allowed
              }
            });
          }}
        >
          <div className="relative">
            <input
              type="checkbox"
              name="remote_allowed"
              checked={formData.remote_allowed}
              onChange={onChange}
              className="sr-only"
              id="remote-checkbox"
            />
            <div className={`w-5 h-5 border-2 rounded flex items-center justify-center transition-all ${
              formErrors.remote_allowed 
                ? "border-red-500" 
                : formData.remote_allowed 
                  ? "border-[#0f6abf] bg-[#0f6abf]" 
                  : "border-gray-300 bg-white"
            }`}>
              {formData.remote_allowed && (
                <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                </svg>
              )}
            </div>
          </div>
          <label htmlFor="remote-checkbox" className="text-sm text-gray-700 cursor-pointer select-none">
            Remote work allowed
          </label>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <input
            type="number"
            name="salary_min"
            placeholder="Min Salary"
            value={formData.salary_min}
            onChange={onChange}
            className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all ${
              formErrors.salary_min 
                ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
                : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
            }`}
          />
          <input
            type="number"
            name="salary_max"
            placeholder="Max Salary"
            value={formData.salary_max}
            onChange={onChange}
            className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all ${
              formErrors.salary_max 
                ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
                : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
            }`}
          />
        </div>

        <input
          type="text"
          name="currency"
          placeholder="Currency (e.g., USD, EUR, INR)"
          value={formData.currency}
          onChange={onChange}
          className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all ${
            formErrors.currency 
              ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
              : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
          }`}
        />

        <div className="grid grid-cols-2 gap-4">
          <select
            name="experience_level"
            value={formData.experience_level || ""}
            onChange={onChange}
            className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all appearance-none ${
              formErrors.experience_level 
                ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
                : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
            }`}
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 16px center'
            }}
          >
            <option value="">Select Experience Level</option>
            {EXPERIENCE_LEVELS.map((exp) => (
              <option key={exp.value} value={exp.value}>
                {exp.label}
              </option>
            ))}
          </select>

          <select
            name="job_type"
            value={formData.job_type}
            onChange={onChange}
            className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all appearance-none ${
              formErrors.job_type 
                ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
                : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
            }`}
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 16px center'
            }}
          >
            <option value="">Select Job Type</option>
            {JOB_TYPES.map((job) => (
              <option key={job.value} value={job.value}>
                {job.label}
              </option>
            ))}
          </select>
        </div>

        <input
          type="text"
          name="skills_required"
          placeholder="Required Skills (comma separated)"
          value={formData.skills_required || ""}
          onChange={onChange}
          className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all ${
            formErrors.skills_required 
              ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
              : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
          }`}
        />

        <input
          type="text"
          name="qualifications"
          placeholder="Qualifications (e.g., B.Tech, M.Sc, PhD)"
          value={formData.qualifications}
          onChange={onChange}
          className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all ${
            formErrors.qualifications 
              ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
              : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
          }`}
        />

        <div className="grid grid-cols-2 gap-4">
          <input
            type="email"
            name="application_email"
            placeholder="Application Email"
            value={formData.application_email}
            onChange={onChange}
            className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all ${
              formErrors.application_email 
                ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
                : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
            }`}
          />
          <input
            type="text"
            name="application_url"
            placeholder="Application URL"
            value={formData.application_url}
            onChange={onChange}
            className={`w-full px-4 py-3 border rounded-xl text-sm outline-none transition-all ${
              formErrors.application_url 
                ? "border-red-500 focus:ring-2 focus:ring-red-500/20" 
                : "border-gray-300 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20"
            }`}
          />
        </div>
      </div>
    </div>

    {/* Footer - Fixed */}
    <div className="border-t border-gray-100 bg-white p-6 sticky bottom-0">
      <button
        onClick={onSave}
        disabled={creating}
        className={`w-full py-3 rounded-xl font-medium transition-all ${
          creating
            ? 'bg-gray-300 cursor-not-allowed'
            : 'bg-[#0f6abf] text-white hover:bg-[#0a5ca8]'
        }`}
      >
        {creating ? (
          <div className="flex items-center justify-center gap-2">
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            {editingJob ? "Saving..." : "Posting..."}
          </div>
        ) : (
          <div className="flex items-center justify-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
            </svg>
            {editingJob ? "Save Changes" : "Post Job"}
          </div>
        )}
      </button>
    </div>
  </div>
</div>

    );
  }
);

export default JobModal;
